<template>
  <div>
    <div
      class="modal fade"
      id="modal-block-add-product-form-manager"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-block-add-product"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-add-service modal-lg"
        role="document"
      >
        <div class="modal-content">
          <div class="block block-themed block-transparent mb-0">
            <div class="block-header bg-primary-dark">
              <h3 class="block-title">Add Product</h3>
              <div class="block-options">
                <button
                  type="button"
                  class="btn-block-option"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="fa fa-fw fa-times"></i>
                </button>
              </div>
            </div>
            <div class="block-content">
              <div class="row">
                <div
                  class="col-md-3 mb-3"
                  v-for="item in products"
                  :key="item.id"
                  v-if="findItem(item.id)"
                >
                  <div class="utility">
                    <div for="product-8">
                      <button
                        data-toggle="modal"
                        data-target="#productAddModal"
                        class="btn btn-warning float-right m-1"
                        style="right: 0; position: absolute"
                        @click="handleEditProducts(item)"
                      >
                        <i class="far fa-edit"></i>
                      </button>
                      <img :src="getImage(item.icon)" />
                      <span>{{ item.name[lang] }}</span>
                      <a style="z-index: 110" class="more">More info</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="productAddModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Edit Suppliers ({{ selectedConnection }})
            </h5>
            <button
              type="button"
              class="btn-close"
              data-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <h4>Delete from forms</h4>
                <div :key="formName" v-for="formName in deleteFromForms">
                  <input type="checkbox" />
                  (
                  <span>{{ formName }}, </span>
                  )
                </div>
                <br />
              </div>
              <div class="col-md-6">
                <h4>Add to forms</h4>
                <div :key="formName" v-for="formName in addToForms">
                  <input type="checkbox" />
                  (
                  <span>{{ formName }}, </span>
                  )
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button type="button" class="btn btn-primary" data-dismiss="modal">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
// import $ from "jquery"
export default {
  name: "AddConnectionFormManager",
  props: ["formsData", "selectedForms"],
  computed: {
    ...mapState({
      products: (state) => state.products.products,
      FormTwoAdded: (state) => state.forms.FormTwoAdded,
      combinations: (state) => state.forms.combinations,
    }),
  },
  data: () => {
    return {
      deleteFromForms: [],
      addToForms: [],
      selectedConnection: "",
    };
  },
  beforeMount() {
    this.getProducts();
  },
  methods: {
    ...mapActions({
      getProducts: "products/getProducts",
      getWidgetById: "widgets/getWidgetById",
    }),
    handleEditProducts(item) {
      this.deleteFromForms = [];
      this.addToForms = [];
      this.selectedConnection = item.name.en;
      this.deleteFromForms = Object.values(this.formsData.products).filter(
        (x) => x.id === item.id
      )[0]
        ? Object.values(this.formsData.products).filter(
            (x) => x.id === item.id
          )[0].forms
        : [];

      let temp = [];
      this.selectedForms.map((form) => {
        temp.push(form.name);
      });
      let temp2 = [];
      temp.map((a) => {
        if (!this.deleteFromForms.includes(a)) {
          temp2.push(a);
        }
      });
      this.addToForms = temp2;
    },
    addProduct: function (item) {
      let productGroup =
        item.code === "energie" ? this.energieGroups[item.id] : item.code;
      let index = this.form.data.fields.length;
      let lastItem = this.form.data.fields[this.form.data.fields.length - 1];
      let newId =
        lastItem.length > 0
          ? lastItem[lastItem.length - 1].id + 1
          : this.form.data.fields.length * 20;

      this.form.data.fields.push([]);

      /* If Has a Duration*/
      if (
        productGroup &&
        this.combinations[productGroup] &&
        this.combinations[productGroup].duration
      ) {
        this.durationWidget(newId, productGroup, item, index);
        newId = newId + 1;
      }

      /* If Has a Supplier*/
      if (
        productGroup &&
        this.combinations[productGroup] &&
        this.combinations[productGroup].supplier
      ) {
        this.form.data.fields[index].push({
          id: newId,
          group: productGroup,
          product: item.id,
          type: "suppliers",
          subtitle: {
            nl: this.enums[productGroup]
              ? this.enums[productGroup].subtitle4Supplier
              : "choosesupplier",
            en: this.enums[productGroup]
              ? this.enums[productGroup].subtitle4Supplier
              : "choosesupplier",
          },
          title: item.name,
          description: item.description,
          css: "custom css",
          suppliers: [],
          speed: [],
          groupDefault: null,
          groupDefaultOld: null,
        });
        newId = newId + 1;
      }

      /* If Has a CustomizedOffer*/
      if (
        productGroup &&
        this.combinations[productGroup] &&
        this.combinations[productGroup].customizedoffer
      ) {
        this.customizedOfferWidget(newId, productGroup, item, index);
        newId = newId + 2;
      }

      /* If Has a Widget*/
      if (
        productGroup &&
        this.combinations[productGroup] &&
        this.combinations[productGroup].widgets
      ) {
        for (var widgetID in this.combinations[productGroup].widgets) {
          this.getWidgetById(
            this.combinations[productGroup].widgets[widgetID]
          ).then((response) => {
            if (
              response[1].data.data.contents &&
              response[1].data.data.id !== 6 &&
              response[1].data.data.id !== 5
            ) {
              this.form.data.fields[index].push({
                id: newId,
                group: productGroup,
                type: "html",
                product: item.id,
                title: response[1].data.data.name,
                description: {},
                css: "",
                widgetCardId: this.combinations[productGroup].widgets[widgetID],
                html: response[1].data.data.contents,
              });
            }
          });
        }
      }

      /* If Electricity and Gas */
      if (
        (!this.findItem(1) && item.id === 2) ||
        (!this.findItem(2) && item.id === 1)
      ) {
        this.$store.state.forms.formStateData.data.fields.push([]);

        this.durationWidget(
          newId + 1,
          "electricityandgas",
          {
            id: 6,
            name: {
              nl: "Stroom + Gas",
              en: "Electricity or Gas",
            },
          },
          index + 1
        );

        this.$store.state.forms.formStateData.data.fields[index + 1].push({
          id: newId + 2,
          group: "electricityandgas",
          product: 6,
          type: "suppliers",
          subtitle: {
            nl: this.enums[productGroup]
              ? this.enums[productGroup].subtitle4Supplier
              : "choosesupplier",
            en: this.enums[productGroup]
              ? this.enums[productGroup].subtitle4Supplier
              : "choosesupplier",
          },
          title: {
            nl: "Electricity or Gas",
            en: "Electricity or Gas",
          },
          description: "",
          css: "custom css",
          suppliers: [],
          speed: [],
        });

        this.customizedOfferWidget(
          newId + 3,
          "electricityandgas",
          {
            id: 6,
            name: {
              nl: "Stroom + Gas",
              en: "Electricity or Gas",
            },
          },
          index + 1
        );
        this.sortSections(index + 1);
      }
      if (productGroup === "electricity" || productGroup === "gas") {
        this.sortSections(index);
      }

      /*Add Product*/
      let productData = this.products.find((x) => x.id === item.id);
      this.$store.state.forms.formStateData.data.fields.filter(
        (x) => x.id === 1 && x.type === "products"
      )[0].title = "";
      productData.group = productGroup ? productGroup : null;
      this.$store.state.forms.formStateData.data.fields
        .filter((x) => x.id === 1 && x.type === "products")[0]
        .products.push(productData);
    },
    sortSections: function (index) {
      let section = this.$store.state.forms.formStateData.data.fields[index];
      let detailedoffer = section[2] ? section[2] : null;
      let chooseduration = section[0] ? section[0] : null;
      let choosesupplier = section[1] ? section[1] : null;
      let customizedoffer = section[3] ? section[3] : null;

      this.$store.state.forms.formStateData.data.fields[index] = [
        detailedoffer,
        chooseduration,
        choosesupplier,
        customizedoffer,
      ];
    },
    findItem: function (id) {
      let status = true;
      this.form.data.fields
        .filter((x) => x.type === "products")
        .forEach((x) => {
          if (x.products.find((item) => item.id === id)) {
            status = false;
          }
        });
      return status;
    },
    durationWidget(newId, productGroup, item, index) {
      this.$store.state.forms.formStateData.data.fields[index].push({
        id: newId,
        group: productGroup,
        product: item.id,
        type: "duration",
        subtitle: {
          nl: "choseduration",
          en: "choseduration",
        },
        title: item.name,
        description: "",
        css: "custom css",
        default: 0,
      });
    },
    customizedOfferWidget(newId, productGroup, item, index) {
      this.$store.state.forms.formStateData.data.fields[index].push(
        {
          id: newId,
          group: productGroup,
          product: item.id,
          type: "detailedoffer",
          subtitle: {
            nl: "detailedoffer",
            en: "detailedoffer",
          },
          title: item.name,
          description: "",
          css: "custom css",
          default: 0,
        },
        {
          id: newId + 1,
          group: productGroup,
          product: item.id,
          type: "customizedoffer",
          subtitle: {
            nl: "customizeoffer",
            en: "customizeoffer",
          },
          title: item.name,
          description: "",
          css: "custom css",
          default: 0,
        }
      );
    },
  },
};
</script>

<style scoped>
.utility img {
  max-width: 40px;
  display: block;
  margin: 0 auto;
  margin-top: 25px;
}

.utility input {
  display: none;
}

.utility div {
  display: block;
  position: relative;
  border: 1px solid #a0a0a0;
  text-align: center;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  height: 160px;
  cursor: pointer;
  transition: background-color 0.2s, box-shadow 0.2s;
}

.utility .more {
  width: 100%;
  background: #f5fbfd;
  display: block;
  text-align: center;
  color: #1678aa;
  padding: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  font-weight: normal;
  font-size: 14px;
}
</style>
